import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DigitalCVModel } from '@digilize/shared/definitions/src';
import { AuthService } from '@digilize/shared/feature/modules/auth/src';
import { DialogService } from '@digilize/shared/utils/services/src';
import { TranslateService } from '@ngx-translate/core';
import { first, of, Subject, switchMap, take, takeUntil } from 'rxjs';

import { ProfileChangesService } from '../../services/profile-changes.service';
import { SharedAccountDataService } from '../../services/shared-account-data.service';
import { ManagePasswordComponent } from '../manage-password/manage-password.component';

@Component({
  selector: 'bwc-profile-menu',
  templateUrl: './profile-menu.component.html',
  styleUrls: ['./profile-menu.component.scss'],
})
export class ProfileMenuComponent implements OnInit, OnDestroy {
  @ViewChild('dropdownContainer') dropdownContainer!: ElementRef;

  openMenu = false;
  showDeleteConfirm = false;
  accountData: DigitalCVModel;
  dataLoaded = false;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private dialogService: DialogService,
    private authService: AuthService,
    private sharedAccountDataService: SharedAccountDataService,
    private profileChangesService: ProfileChangesService,
    private dialog: MatDialog,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.sharedAccountDataService.cv$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.accountData = data;
      if (data) {
        this.dataLoaded = true;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get isActivated(): boolean {
    return this.dataLoaded && !!this.accountData?.activated;
  }

  toggleNav() {
    this.openMenu = !this.openMenu;
  }

  @HostListener('document:click', ['$event'])
  onClick(event: Event) {
    if (!this.dropdownContainer?.nativeElement.contains(event.target)) {
      this.openMenu = false;
    }
  }

  changePassword() {
    if (!this.isActivated) return;
    this.dialogService.openDialog(ManagePasswordComponent, {
      disableClose: false,
      width: '670px',
      data: { type: 'change', email: this.accountData.email },
    });
  }

  saveProfile() {
    if (!this.isActivated) return;
    this.dialogService.openDialog(ManagePasswordComponent, {
      disableClose: false,
      width: '670px',
      data: { type: 'create', email: this.accountData.email },
    });
  }

  deleteAccount() {
    this.showDeleteConfirm = true;
  }

  logout() {
    if (!this.isActivated) return;
    this.profileChangesService.hasChanges$
      .pipe(
        first(),
        switchMap((has) => {
          return has ? this.profileChangesService.saveCompleted$.pipe(take(1)) : of({});
        })
      )
      .subscribe(() => {
        this.authService.logout('/login');
      });
  }
}
